import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import isNil from 'lodash/isNil';

import { IconCellService } from '../icons/Icons';

import describeCoverage from './describeCoverage';
import describeCoverageAlt from './describeCoverageAlt';

export default function MobileCoverageRating({
    rating,
    className,
    hasDescription,
    hasLeftBorder
}) {
    const averageRating = rating > 4 ? 4 : Math.round(rating);
    const description = describeCoverage(averageRating);
    const descriptionAlt = describeCoverageAlt(averageRating);

    if (isNil(rating)) {
        return null;
    }

    return (
        <div
            data-component="MobileCoverageRating"
            className={cx('sarsa-mobile-coverage-rating', className, {
                'has-left-border': hasLeftBorder})}>
            <IconCellService
                role="img"
                aria-label={`Mobile signal rating ${averageRating}`}
                className={`cell-coverage-icon coverage-${averageRating}`}
                alt={!hasDescription ? descriptionAlt : ''}
            />

                {hasDescription && (
                    <span className="description">
                        {description}
                    </span>
                )}
        </div>
    );
}

MobileCoverageRating.propTypes = {
    /** Number between 0 and 4 (inclusive). Can be a floating point number */
    rating: PropTypes.number,

    /** Additional class added to the outer container */
    className: PropTypes.string,

    /** Hide the description to the right of the service icon */
    hasDescription: PropTypes.bool,

    /** Add a border before the icon. Useful when displaying inline with the StarRating component */
    hasLeftBorder: PropTypes.bool
}

MobileCoverageRating.defaultProps = {
    hasDescription: true,
    hasLeftBorder: false
}